<template>
  <section class="delete-overlay flex items-center justify-center text-center">
      <div>
        <h3>{{item.name}}</h3>
        <p>Is Being deleted</p>
        <i class="far fa-spinner-third fa-spin" />
      </div>
  </section>
</template>

<script>

export default {
  name: "DeleteOverlay",

  props: {
    item: {
      type: Object,
      required: true
    }
  },
}
</script>